import CommonImage from "@/components/common/image/CommonImage";
import Image from "next/image";
import Link from "next/link";
import React from "react";

export default function BranchCard({
  title,
  number1,
  number2 = "",
  number3 = "",
  slug,
  address,
}) {
  return (
    <div className="branch-card">
      <div className="top-icon-wrap">
        <div className="top-icon">
          <Image
            src={"/images/admission-icon/branch-location-icon.png"}
            className="img-icon"
            alt="icon"
            fill
          />
        </div>
      </div>

      <div className="branch-header">
        <h2 className="title">{title}</h2>
        <h3 className="subtitle">{address}</h3>
      </div>

      <div className="content-part">
        <div className="number">
          <span className="relative w-4 h-4">
            <Image
              src={"/images/admission-icon/call-icon.png"}
              className="img-icon"
              alt="icon"
              fill
            />{" "}
          </span>{" "}
          <a href={`tel:${number1}`} className="number_text">
            {number1}
          </a>
        </div>
        {number2 && (
          <div className="number">
            <span className="relative w-4 h-4">
              <Image
                src={"/images/admission-icon/call-icon.png"}
                className="img-icon"
                alt="icon"
                fill
              />{" "}
            </span>{" "}
            <a href={`tel:${number2}`} className="number_text">
              {number2}
            </a>
          </div>
        )}
        <Link href={`/branches/${slug}`} className="branch-btn">
          লোকেশন দেখুন
        </Link>
      </div>
    </div>
  );
}
